export const useAbortTimeout = (timeout = 5000) => {
  const controller = new AbortController();

  setTimeout(() => {
    controller.abort();
    window.FETCH_TIMEOUT_ERROR = true;
  }, timeout);

  return controller.signal;
};

declare global {
  interface Window {
    FETCH_TIMEOUT_ERROR?: boolean;
  }
}
